import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a75e4568295d5001407eebd_1786113046613_550e903b/kavris/src/app/atlas/components/AtlasWorkspace.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a75e4568295d5001407eebd_1786113046613_550e903b/kavris/src/components/AppLayout.tsx");
